<template>
  <div>
    <div :class="params.class?params.class:'reg-form-inp one-log'">
      <select :name="params.name" :placeholder="params.placeholder+(params.required?' *':'')">
        <option :value="option.value" :data-city="option['data-city']" :class="option.class" v-for="option in params.variants">{{option.text}}</option>
      </select>
      <div class="error-info" v-if="params.error" v-html="params.error"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "order_select",
  props:['params']
}
</script>

<style scoped>

</style>